// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_3V3Hj","logo":"index_logo_h1KsM","logoAnimate":"index_logoAnimate_3Kzwz","mainLogo":"index_mainLogo_3uXgc","version":"index_version_nigfu"};